var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTamplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 1396",
    width: 739,
    height: 504,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2048v1396h-2048z",
    fill: "#C4D3E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2048v1396h-2048zm208 450-11 4-9 7-6 7-5 10-1 3-1 706v59l1 25 3 8 6 10 9 8 11 5 5 1h1631l9-2 11-7 8-9 6-12 1-8v-108l-1-678-6-12-10-10-12-6-5-1z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1516,723)",
    d: "m0 0h15l9 4 9 6 14 11 15 9 7 6 2 4v7l5 1 10 9 5 8 2 5v20l-2 6v6l2 7-2 11-6 7-9 3-6 7-6 11-9 12-4 3v11l1 8 3 1 16 1 28 5 24 8 17 8 19 12 14 11 12 11 8 8 9 11 11 15 9 15 6 11 3 8 4 10 5 15 3 13 2 19v17l-4 20-4 12-7 13-9 11-11 9-11 7-15 7 128 1 8 7 1 4v12l-6 8-1008 1h-589l-6-5-3-7v-8l4-8 6-4 120-1-4-10v-17l5-10 8-8 9-4h18l14 7 2 3-28 1-8 4-6 7-1 3v11l4 8 6 5h208l6-5 3-6v-13l-3-7-6-5-5-2-36-1 2-4 4-5 1-9-4-4-2-1h-8l-8 8h-2v-17h140v61h46l4-18 7-25 4-16 7-24 9-36 7-25 6-23 1-2h236l-1 9-8 29-8 31-16 61-4 15-6 23-1 12h100l-1-85-11-15-9-17-6-17-1-4v-17l4-6 4-3 9-1 1 1 4-15 5-7 8-5h2l1 4 1-4h9l6 2 6 4v-10l3-14 5-12 7-7 3-1h11l8 4 7 8 5 13 3 24 5-8 9-7 6-2h8l8 4 5 8 1 10-3 15-7 20-11 22-11 18-10 16-1 24v60h111l-2-15-9-36-6-21-13-50-12-45-3-12v-3l189-1 12-16 11-14 12-14 14-14 18-13 14-8 16-7 22-5 9-1h11l-3-14v-4l-11-3-10-5-10-9-6-8-7-14-1-4v-8l5-14 10-16 1-1 3-24 1-6-6-9-1-3v-18l4-10 9-10 10-5z",
    fill: "#575E92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1516,723)",
    d: "m0 0h15l9 4 9 6 14 11 15 9 7 6 2 4v7l5 1 10 9 5 8 2 5v20l-2 6v6l2 7-2 11-6 7-9 3-6 7-6 11-9 12-4 3v11l1 8 3 1 16 1 28 5 24 8 17 8 19 12 14 11 12 11 8 8 9 11 11 15 9 15 6 11 3 8 4 10 5 15 3 13 2 19v17l-4 20-4 12-7 13-9 11-11 9-11 7-16 8h-85l-7-3-5-1 6 3v1h-18v-7l1-4h-113l-6-23-2-7-2-10-3-9-7-26-2-7-12-46-11-42-48-1 7-11 13-16 8-10 12-13 9-9 18-13 14-8 16-7 22-5 9-1h11l-3-14v-4l-11-3-10-5-10-9-6-8-7-14-1-4v-8l5-14 10-16 1-1 3-24 1-6-6-9-1-3v-18l4-10 9-10 10-5z",
    fill: "#AC69A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,44)",
    d: "m0 0h953l16 1 11 4 8 6 8 8 6 12 1 3v18l-4 12-7 9-7 7-8 5-10 3h-992l-12-2-10-5-4-3v-2l-4-2-9-14-2-6v-19l4-11 7-10 7-6 9-5 11-2z",
    fill: "#D8D8D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,966)",
    d: "m0 0h11l8 4 8 9v12l-14 26 14-7 7-8 3-9v-15l-1-6h165l10 4 9 6 6 9 2 6 1 24 6-5 6-8 3 3 11 19 7 11 2 2-1 8-9 34-7 25-3 14-2 6-8 30-4 13h-46v-61h-140v17l8-7 2-2h8l5 3 2 3-1 9-7 9h36l8 4 6 7 1 4v13l-5 8-5 4h-208l-8-7-3-7v-11l4-7 7-6 5-2 27-1-10-6-9-3-10-1 2-5 8-13 13-23 10-17 15-26 10-17 12-21 10-17 11-19 7-7z",
    fill: "#F8F8F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1196 1e3)",
    d: "m0 0h237l3 9 11 42 10 38 2 7 9 34 2 7 2 5 5 21 1 8 105-1 8 1-1 11h-122l-76-1h-150l-6-26-6-24-6-21-13-50-12-45-3-12z",
    fill: "#2C3958"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(755 1e3)",
    d: "m0 0h236l-1 9-8 29-8 31-16 61-4 15-7 26-1 9-106-1h-44l-77 1h-119v-10l5-1h105l4-18 7-25 4-16 7-24 9-36 7-25 6-23z",
    fill: "#2C3958"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1141,678)",
    d: "m0 0 5 1 4 14 1 8 8 2 21 4 1-4 9-15 5 2 20 12 12 7-1 5-8 12-3 4 2 4 11 16 13-2 10-2 3 7 7 30-1 5-21 5-5 24v3l19 11 1 4-11 19-11 15-4-2-15-9-4-1-14 10-6 2 5 24v2l-12 3-25 6h-5l-5-21v-3h-7l-13-3h-4l-10 16-4 4-24-15-12-8 2-4 7-10 3-5-2-4-9-12-4-7-11 2-13 2-3-8-7-33 13-4 11-1 2-18 2-10-6-2-13-8 8-14 15-22 5 2 14 8h2l5-5 14-9-2-10-3-12v-3z",
    fill: "#99A5C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,564)",
    d: "m0 0h191l9 3 7 6 4 8 1 3v87l-3 7-8 9-4 2-6 1-137 1-38 28-4 3h-3v-32h-14l-8-3-6-5-5-9v-87l3-10 6-7 9-4z",
    fill: "#858FBD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,783)",
    d: "m0 0 4 1 45 1 4 4 2 10 34 1 13 4 8 6 7 7 6 11 2 10v70l-4 16-6 12-5 6-10 6-12 3h-132l-11-4-8-6-8-9-5-11-2-7-1-19v-37l2-22 5-15 7-10 9-7 8-3 6-1 34-1 3-10 2-4z",
    fill: "#F7F7F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1282,547)",
    d: "m0 0h143l53 1 10 5 6 8 2 8v86l-4 8-9 8-6 2h-14v33l-4-1v-2l-5-2-19-14-13-10-5-3-136-1-10-3-8-8-3-8v-84l2-9 6-8 8-5z",
    fill: "#858FBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1097,955)",
    d: "m0 0h11l8 4 7 8 5 13 3 24 5-8 9-7 6-2h8l8 4 5 8 1 10-3 15-7 20-11 22-11 18-10 16-1 24v60h-83l-1-85-11-15-9-17-6-17-1-4v-17l4-6 4-3 9-1 1 1 4-15 5-7 8-5h2l1 4 1-4h9l6 2 6 4v-10l3-14 5-12 7-7z",
    fill: "#AA8598"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1516,723)",
    d: "m0 0h15l9 4 9 6 14 11 15 9 7 6 2 4v7l5 1 10 9 5 8 2 5v20l-2 6v6l2 7-2 11-6 7-9 3-6 7-6 11-9 12-4 3v11l1 8 3 2h-3v6l-5 8-8 6-11 5-11 2-7-3-3-4-1-6 2-11h-11v-1h11l-3-14v-4l-11-3-10-5-10-9-6-8-7-14-1-4v-8l5-14 10-16 1-1 3-24 1-6-6-9-1-3v-18l4-10 9-10 10-5z",
    fill: "#D1BFC1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,825)",
    d: "m0 0h106l9 3 8 6 5 7 2 6v51l-3 12-6 9-7 5-7 2h-107l-10-5-8-9-3-7-1-5-1-34 2-18 4-10 6-8 7-4z",
    fill: "#2D3A59"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,713)",
    d: "m0 0h6v8h15l9 1 1-7 4-1 6 2v6l-1 3 16 10 4 1 3-4 5 2 3 3-1 5-4 2 10 20h9l2 6v4l-8 3v21l6 2v7l-1 3-4 1-6-1-4 8-6 8 1 4 3 3-2 4-4 3-5-2-4-2-10 6-6 3h-2l2 9-6 2h-5l-1-1v-7h-23l-2 6-4 1-7-3 1-9-12-7-7-4-2 4h-5l-4-4v-5l4-2-2-6-7-14-9 1-2-5v-6l7-2 1-22-6-2-1-4 2-7 10 1 7-13 4-6-4-2-1-5 6-5 4 1 2 5 12-7 8-3v-10z",
    fill: "#7A85AF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,586)",
    d: "m0 0h1v89l-7 9-5 4-8 2-137 1-38 28-4 3h-3v-32h-14l-8-3-6-5-5-9v-6h19l2-2 107-1 4-2 1-6v-3l-3-1 4-4 10-3 6-3h3l1-3h2l2-4 3-1 54-1 2-2 1-8-4-2-34-1v-1l19-1 11-8 13-10 7-6 2-3h2z",
    fill: "#7984AF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1261,571)",
    d: "m0 0 4 5v2l4 2 15 12 9 7-3 1v2l-9 3-2 3 1 7 1 1 48 1 11 1-1 4 4 1 21 10v4 9l5 1h110l1 2 15 1v8l-6 8-6 5-6 2h-14v33l-4-1v-2l-5-2-19-14-13-10-5-3-136-1-10-3-8-8-2-5z",
    fill: "#7984AF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,575)",
    d: "m0 0 3 1 1 10 8 1 1-5 2-6 10 2 6 2-1 9-1 3 4 3h3l5-5 3-1 6 5 4 5-1 4-5 4-1 4 2 3 7-1 5-1 2 5 1 12-7 2-5 1 2 7 10 3-2 10-3 7-10-3-2-1-2 7 6 7-2 5-6 5-2 3-3-1-6-7-6 2 1 13-15 3-4-10-1-1h-6l-3 10-13-3-3-2 2-11-3-3-4 1-6 5-5-2-6-7v-5h2l1-3 3-3-2-5-11 1-2-2-2-8v-6l10-3 1-4v-4l-8-1-3-1 2-9 3-7 12 2 2-7-3-2v-2h-2l-1-5 10-9 4 2 6 5 6-2-2-12 8-3z",
    fill: "#AA8598"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1516,723)",
    d: "m0 0h15l9 4 9 6 14 11 15 9 7 6 2 4v7l5 1 10 9 5 8 2 5v20l-4 10-6-3-9-1v2h-5l-8-10-7-14-2-6v-9l-13-1-13-2-17-1-14 2-4 4-4 8-2 5-3 5-4 4v-12l1-9 1-6-6-9-1-3v-18l4-10 9-10 10-5z",
    fill: "#2D3A59"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(925,744)",
    d: "m0 0h18l10 4 9 6 6 8 4 8 2 9v13l-4 13-7 9-8 6-12 5-5 1h-10l-13-4-7-4v-2l-4-2-6-9-4-10-1-5v-12l3-12 8-11 8-6 9-4z",
    fill: "#C4D3E4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1144,751)",
    d: "m0 0h13l11 4 9 7 7 10 4 11v17l-3 9-6 9-9 8-12 5-4 1h-12l-11-4-9-6-7-9-5-13-1-5v-11l5-14 9-10 8-5z",
    fill: "#C5D4E5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(479,1040)",
    d: "m0 0h1l1 43 4 13 7 8 12 6 5 1 15 1v17l2 1-5 4-7 8-3 2h-91l1-4 16-28 14-24 13-23 11-19z",
    fill: "#C5D4E4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1151,987)",
    d: "m0 0h8l8 4 5 8 1 10-3 15-7 20-11 22-11 18-10 16-1 1h-25v-14l6-35 6-20 4-9 3-8h2l2-9 1-12h1l1 10 5-8 9-7z",
    fill: "#848EBC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(709,1070)",
    d: "m0 0 4 5 13 22 2 10-4 17-2 6-8 30-4 13h-46v-61l17-1 11-4 8-6 5-9 2-6z",
    fill: "#C4D3E4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1078 1e3)",
    d: "m0 0h2l8 14 4 13 2 10 2 19v7l-6 8-8 10-1 2-3-1-5-22v3l6 23 2 15h-13l-6-9-4-8-1-5 9 3 10 4v-2l-5-1v-2l-11-3-6-4-7-16-3-9v-3l5 1 16 7h2l-9-4-12-5-4-4-3-11v-15l2-2 14 5 6 4 1 5h2l4 16 2 6-7-29 8-10z",
    fill: "#6D7AA2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1097,955)",
    d: "m0 0h3l3 13 3 35v41l-2 16-1 16-2 14-1 11h-3l-1-33-11 13-4 5 1 8 2 7h-2l-2-3-4-18-5-20 1-4 4 12 3 15 2 1 2-5 9-10 3-5-1-15-2-16-3-11-4-11-5-8v-2l-5 5-10 14-1 2 7 28-1 4-5-16-1-10h-2l-2-5-12-6-7-2-2 1 1-9 6-9 8-5h2l1 4 1-4h9l6 2 6 4v-10l3-14 5-12 7-7z",
    fill: "#99A5C9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(524,1112)",
    d: "m0 0h140v21h-114l-2-7-4-4-2-1h-8l-8 8h-2z",
    fill: "#2C3958"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(106,44)",
    d: "m0 0h7v3l4 1 2-4h6l7 5 6 2 8 11 3 15 1 2v20l-3 4h-3v7l-3 3-9 1-5 4h-7l-2-5 4 2 6-1 3-6 3 2 6-1 2-8 4-2v-7l-2-1 1-3h2l-3-16-2-3v-6l-7-10-7-2-4-3-5 1-1 1-1 61-3 5-4 3h-5l-6-5-8-1-3-3-3-7-4-4 1-11-1-6 4-14 2-8 3-3 3-5 5-3 5-2z",
    fill: "#EEEDEF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1151,987)",
    d: "m0 0h8l8 4 5 8 1 10-3 15-7 20-2 4h-9l-16-6-12-7-5-4 1-6 4-10h2l2-9 1-12h1l1 10 5-8 9-7z",
    fill: "#858FBD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1100,955)",
    d: "m0 0h8l8 4 7 8 5 13 1 6v20l-3 9h-2l-3 10-5 13-5 19-5 30-1 15h-5v-12l2-14 1-16 2-16v-41l-3-35-2-8z",
    fill: "#596094"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1038,1018)",
    d: "m0 0h1l1 13 3 13 5 2 16 6 4 4-5-1-19-8 6 17 6 12 15 6v2l5 1v2l-10-3-8-3 4 10 5 10h-19l-1 3-2-6-11-16-8-15-6-17-1-4v-17l4-6 4-3 9-1 1 1z",
    fill: "#99A5C9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,589)",
    d: "m0 0h120l5 2v10l-3 2h-128l-5-2-2-3v-5l3-3z",
    fill: "#F2F4F6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1379,572)",
    d: "m0 0h90l9 2 1 7-1 4-2 1h-132l-3-2-1-8 2-3z",
    fill: "#F3F4F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,47)",
    d: "m0 0 6 1 3 3 7 2 7 10v6l2 3 2 10v6l-3 3 3 1v7l-5 2v6l-4 4-5-1h-2l-3 5-6 1-3-2h-3l1-64z",
    fill: "#E5E5E7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,611)",
    d: "m0 0h10l9 4 6 8 2 6v10l-5 10-9 6-2 1h-14l-8-5-4-5-3-7v-11l3-7 4-5 7-4z",
    fill: "#C5D3E3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,651)",
    d: "m0 0h94l5 2 1 7-3 4-3 1h-105l-5-3-1-6 3-4z",
    fill: "#F2F4F6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1536,1147)",
    d: "m0 0h16l6 1 17 1 4 8 1 10-1 5h-59l4-1v-2l11-4 2-2-8 1-13 8h-15l2-5 7-8 8-6 13-5z",
    fill: "#D2C0C2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(747,621)",
    d: "m0 0h114l3 2v8l-3 3h-112l-4-3v-8z",
    fill: "#F5F6F7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1281,604)",
    d: "m0 0h114l2 2v9l-3 2h-113l-3-4 1-7z",
    fill: "#F5F6F6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1365,635)",
    d: "m0 0h112l1 1v10l-4 2h-105l-6-2v-9z",
    fill: "#F4F6F7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,564)",
    d: "m0 0h94v1l-10 2-3 2-36 5-38 9-16 5-10 4h-4v9h-1v-15l3-10 6-7 9-4z",
    fill: "#9AA6CA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1565,889)",
    d: "m0 0h1l2 16 3 2h-3v6l-5 8-8 6-11 5-11 2-7-3-3-4-1-6 2-11h-11v-1h11l-3-14 1-3 1 1v7l20-1 14-3 7-4z",
    fill: "#D1BFC1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1419,547)",
    d: "m0 0 59 1 10 5 6 8 2 8v70h-1v-64l-7-1-11-5-15-4-19-6-23-4-32-3-6-1-2-1-20-1v-1z",
    fill: "#9AA6CA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(478,955)",
    d: "m0 0h14l10 3 8 6 6 9 2 5v15l-4 10-7 8-12 6h-2l2-6 11-20v-12l-8-9-7-3h-11l-6 3-7 8-10 18h-2l-1-3v-14l3-8 6-8 9-6z",
    fill: "#354164"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,1122)",
    d: "m0 0h1l1 62h-66l3-2 16-6 16-9 11-10 10-16 5-13z",
    fill: "#AC6AA4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,964)",
    d: "m0 0h16l11 5 4 5 5 5 3 6 1 4v13l-3 8-7 9-4 3-1-1-1-24-4-9-4-6-9-6-9-3-11-1v-2l9-5z",
    fill: "#2F3C5C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,1006)",
    d: "m0 0 2 3 4 5v2l4 2 10 6 9 4 10 2-2 9-4 9h-9l-16-6-12-7-5-4 1-6 4-10h2z",
    fill: "#848EBC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1044,1047)",
    d: "m0 0 5 1 16 7 5 4 1 5h2l6 23 2 15h-13l-6-9-4-8-1-5 9 3 10 4v-2l-5-1v-2l-11-3-6-4-7-16-3-9z",
    fill: "#585F93"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1946,61)",
    d: "m0 0h8l6 3 6 7 1 4v8l-4 6-4 4-4 2h-11l-6-4-4-5-1-3v-11l4-6 5-4z",
    fill: "#F3F2F4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(373,1134)",
    d: "m0 0h18l14 7 2 3-28 1-8 4-6 7-1 3v11l4 8 4 4v2h-7v-2h-4l-4 2-3-3-3-8v-17l5-10 8-8z",
    fill: "#303D5D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(106,44)",
    d: "m0 0h7l1 5-7-1-4 2v2l-7 1-3 6-3 3v7l-2 3-3 9v5l2 3-1 4-1 5 2 2 4 1v7l2 2 8-1 3 5 6 1 3-3 1-62 5-6h6l7 5 6 2 8 11 3 15 1 2v20l-3 4h-3v7l-3 3-9 1-5 4h-7l-2-5 4 2 6-1 3-6 3 2 6-1 2-8 4-2v-7l-2-1 1-3h2l-3-16-2-3v-6l-7-10-7-2-4-3-5 1-1 1-1 61-3 5-4 3h-5l-6-5-8-1-3-3-3-7-4-4 1-11-1-6 4-14 2-8 3-3 3-5 5-3 5-2z",
    fill: "#242738"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1118,1031)",
    d: "m0 0 5 2 11 7 15 6 11 2-2 6-6 12-9-1-19-8-11-7v5l-2 1 1-8 5-16z",
    fill: "#848EBC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(206,71)",
    d: "m0 0h23l6 5 2 4v8l-4 6-5 3h-15v13h-7z",
    fill: "#161A26"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1417,604)",
    d: "m0 0h60l1 1v11l-3 1h-57l-3-4 1-8z",
    fill: "#F6F6F6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(770,332)",
    d: "m0 0h11l2 2 1-2h5v33l-4 6-4 2h-10l-6-4v-4l6 2 2 1h6l4-1 1-10-5 4h-8l-7-6-1-3v-11l4-7z",
    fill: "#181C29"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(667,621)",
    d: "m0 0h57l2 1 1 6-2 5-2 1h-54l-5-3-1-6z",
    fill: "#F5F6F7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1040,1014)",
    d: "m0 0 10 3 10 5 2 3v3h2l4 16 1 3v7l-5-1-16-6-5-3-4-13v-15z",
    fill: "#6D79A2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(376,267)",
    d: "m0 0h4v4l6-4h8l7 6 1 2v13l-3 6-4 3-8 1-5-4-1 14h-5z",
    fill: "#1B1E2B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,332)",
    d: "m0 0 5 1v2l4-3h10l5 5 2 5v10l-3 6-4 3-3 1h-7l-4-3v12l-1 2-4-1z",
    fill: "#151924"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,322)",
    d: "m0 0h5v39l-4 1-1-2-4 1-2 1h-7l-6-5-2-5v-12l4-6 3-2h10l3 3z",
    fill: "#181C29"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,258)",
    d: "m0 0h5v39h-4v-3l-5 3-7 1-5-3-3-3-2-5v-10l4-7 2-2 10-1 5 3z",
    fill: "#151823"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1023,1023)",
    d: "m0 0h2l1 4 2 14 8 24 11 21 7 10 3 5h-9l-1 3-2-6-11-16-8-15-6-17-1-4v-17z",
    fill: "#858FBD"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(696,848)",
    d: "m0 0h7l5 3 1 1v46l-3 4-3 1h-7z",
    fill: "#707CA5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1525,777)",
    d: "m0 0 25 2 18 3 2 12 5 12 7 10 3 4 3 2-2 1-1 4-4-1-12-12-5-10-2-10v-8h-12l-7-1h-24l-8 1-3-1-2 1 2-5 3-2z",
    fill: "#A88599"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,724)",
    d: "m0 0h10l5 3 4 5 1 2v9l-6 7-4 2h-10l-6-4-3-4v-11l3-5z",
    fill: "#6D7AA2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,267)",
    d: "m0 0h8l5 3 4 5 1 3v7l-3 8-8 5h-6l-6-4-3-5-1-2v-9l4-8z",
    fill: "#181C28"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,267)",
    d: "m0 0h7l6 4 3 5v11l-3 6-5 4-8 1-6-3-4-6v-14l6-7z",
    fill: "#181B27"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(227,267)",
    d: "m0 0h9l7 6 1 2v14l-4 6-6 3-9-1-5-6-2-4v-9l3-7z",
    fill: "#171A26"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(226,332)",
    d: "m0 0h11l5 4 2 3v14l-5 7-4 2h-9l-5-4-3-7v-11l6-7z",
    fill: "#191C28"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,1135)",
    d: "m0 0h18v2l6-2 2 4v-2l4 2 3 3v2h2l2 8-7 6-7 1v2h-6l-1 3-5-10-3-4-5-4-5-6h-3v-3z",
    fill: "#6D7AA2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,848)",
    d: "m0 0h6l1 55h-7l-6-3v-49z",
    fill: "#6E7BA3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,951)",
    d: "m0 0h29v21h-30v-20z",
    fill: "#707CA5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1568,907)",
    d: "m0 0h19l2 1-1 3-2 1-10 1-5 5-4 7-6 6h-2v2l-9 5-5 3h-9l-8-3-7-5-4-8 2-6-1-5-5-1-4 1-1-3 5-1h11v7l-1 7 3 6 7 3 14-3 11-6 5-4 4-7z",
    fill: "#616093"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1107,963)",
    d: "m0 0 4 1 5 5 3 10 1 13v13l-3 3h-3l-3-9-4-9v52h-1l-1-39-3-39z",
    fill: "#6D7AA3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(180,71)",
    d: "m0 0h15l3 2v4l-18 1-1 1v5l7 3 10 4 4 4v9l-5 5-7 2h-11l-5-3v-4h18l2-2v-5l-6-3-11-4-3-4v-10l5-4z",
    fill: "#171924"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,267)",
    d: "m0 0h4l2 3 4-3h6l4 3 5-2 2-1h7l5 5v25h-5l-1-24-1-1h-6l-3 3-1 22h-5l-1-23-2-2h-5l-3 3-1 22h-5z",
    fill: "#1A1F2E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,267)",
    d: "m0 0 4 1v2l5-3h7l3 3 5-2 9-1 5 5v25h-5l-1-24-1-1h-6l-3 4-1 21h-5l-1-24-1-1h-6l-3 3-1 22h-5v-29z",
    fill: "#1B1E2C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(748,267)",
    d: "m0 0h8l5 3 4 7v6l-1 1h-20l2 8h10l4-2 1-2 3 1-1 4-5 4-3 1h-7l-5-3-4-7v-12l5-7z",
    fill: "#1A1D2A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,267)",
    d: "m0 0h9l7 6 1 4v7h-21l3 7 1 1h9l5-4h2v5l-8 5h-7l-6-4-4-7v-9l3-6z",
    fill: "#181B27"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1107,1074)",
    d: "m0 0 1 4 6 2 17 8 5 2-2 5-4 6h-25v-14z",
    fill: "#838DBB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(545,332)",
    d: "m0 0h12l4 4 1 3v21l-1 2-7-1-2 1h-8l-5-5v-8l3-3 10-3h5l-2-6h-8l-4 3-3-1 1-4z",
    fill: "#171925"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(302,267)",
    d: "m0 0h3v3l6-3h7l4 3 4-2 1-1h8l5 5v25h-4l-1-23-2-2-7 1-1 1-1 23h-5l-1-23-2-2h-5l-3 2-1 23h-5z",
    fill: "#171A26"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,267)",
    d: "m0 0h9l6 5v25h-3v-3l-7 4-9-1-4-5v-7l5-4 7-2h6l-2-7h-6l-5 3-4-1 1-4z",
    fill: "#171A26"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(483,331)",
    d: "m0 0 7 1 5 3 3 5v8h-21l3 7 2 2h7l4-3h4l-1 4-7 4h-8l-5-3-4-8v-10l4-6 4-3z",
    fill: "#181C29"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,332)",
    d: "m0 0h11l6 5 2 5v6h-22l3 7 3 2 8-1 3-2h3l-1 5-6 3h-9l-6-5-3-7v-7l3-6z",
    fill: "#1A1C29"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(318,332)",
    d: "m0 0h10l5 4 2 5v7l-20 1 2 6 3 2 8-1 3-2h4l-1 4-6 4h-10l-6-5-3-7v-7l3-6z",
    fill: "#191C28"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(401,331)",
    d: "m0 0 7 1 6 5 2 4v7h-21l3 8 2 1 9-1 2-2h4l-1 4-4 3-3 1h-8l-6-4-3-7v-10l5-7z",
    fill: "#181B28"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1932,92)",
    d: "m0 0 3 1-1 4-5 9v9l9 3h23l8-3 1-1v-9l-3-6-3-4 1-3 4 1 6 9 2 6-1 7-5 5-6 3-7 1h-20l-10-4-5-5v-10l4-8z",
    fill: "#191C28"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1151,987)",
    d: "m0 0h8l8 4 5 8 1 10-1 2-12-3-11-6-7-6-1-4 7-4z",
    fill: "#858FBD"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1426,73)",
    d: "m0 0h5l3 5 4 10 1 3 2 1 1-4 5-13 2-2h5v28h-4v-19h-2l-1 6-5 12-4 1-5-12-2-5-1 17h-5v-27z",
    fill: "#141722"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1946,61)",
    d: "m0 0h8l6 3 6 7 1 4v8l-4 6-4 4-4 2h-11l-6-4-4-5-1-3v-11l4-6 5-4zm0 5-6 4-2 3v9l3 5 3 3h10l6-5 2-3v-8l-5-6-3-2z",
    fill: "#171925"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(620,864)",
    d: "m0 0h11l6 7v8l-1 3h-2l-2 4-2 1h-10v-2l-4-1-2-3v-9l4-6h2z",
    fill: "#D5D2D5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(558,864)",
    d: "m0 0h8l5 2 2 2v3h2v9l-5 6-2 1h-9l-5-3-2-3v-11z",
    fill: "#D4D1D4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1633,1121)",
    d: "m0 0 2 1-10 7-15 8-19 8h-2l5 15v10l-3 1-5-2v2l-6 1-2-15-3-9 20-7 25-12 10-6z",
    fill: "#5B5E92"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1096,1066)",
    d: "m0 0h1v36h-13l-4-12 1-5 10-12z",
    fill: "#6D7AA2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(931,80)",
    d: "m0 0 6 1 7-1 5 3 1 2v11l-5 5h-6l-2-1-1 8-4 1-1-1z",
    fill: "#12151F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1169,73)",
    d: "m0 0h5l1 8 1-1h8l3 3 1 3v10l-5 5-14-1z",
    fill: "#131620"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1496,73)",
    d: "m0 0h4v28h-3v-2l-4 2h-7l-4-4-1-2v-9l3-5 2-1h7l3 2z",
    fill: "#131621"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,73)",
    d: "m0 0h15l5 5v8l-5 5-10 1v9h-5z",
    fill: "#131620"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1122,73)",
    d: "m0 0h14l5 4 1 2v7l-5 5-10 1v9h-5z",
    fill: "#181C2A"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(242,71)",
    d: "m0 0h7v34h19l1 4-1 1h-26z",
    fill: "#181B28"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1078 1e3)",
    d: "m0 0h2l8 14 2 7-1 7-8 10-3 5h-2l-1 2-5-3v-6l2-2 5-1 3-10 1-5-4-8-1-7z",
    fill: "#575D92"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,80)",
    d: "m0 0h6l3 2 2-2h7l3 3v18h-5l-1-16-5 1-1 15h-5l-1-16-5 1-1 15-5-1v-19z",
    fill: "#151925"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,775)",
    d: "m0 0h36l2 2v7h-41z",
    fill: "#6C79A1"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,73)",
    d: "m0 0h5v12h12v-11l1-1h5v28h-6v-12h-12v12l-5-1z",
    fill: "#191B27"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,332)",
    d: "m0 0h5v3l4-3h9l3 1 3 5v24h-5l-1-25h-9l-3 1-1 24-5-1z",
    fill: "#191D2B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,80)",
    d: "m0 0h8l5 5 1 6-2 6-4 4h-9l-4-5-1-2v-8l4-5z",
    fill: "#181C28"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(622,80)",
    d: "m0 0h8l5 4 1 2v10l-6 5h-7l-5-3-1-3v-10z",
    fill: "#151823"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(442,332)",
    d: "m0 0h5l1 21 1 3h7l3-2 1-22h5v30l-4-1v-3l-6 4h-7l-5-5-1-5z",
    fill: "#1B1F2C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1285,80)",
    d: "m0 0h7l5 4 1 2v9l-4 5-2 1h-8l-5-5v-10l4-5z",
    fill: "#151823"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1465,80)",
    d: "m0 0h7l5 4 1 7-2 7-3 3h-9l-5-5v-10l4-5z",
    fill: "#161A26"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1074,1072)",
    d: "m0 0 2 4 4 17 1 9h-13l-6-9-4-8-1-5 9 3 10 4v-2l-5-1 3-1z",
    fill: "#595F93"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(513,982)",
    d: "m0 0h2l1 3v14l-4 7-8 7-9 4h-2l2-6 10-18 4-2 2-7h2z",
    fill: "#364365"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(251,331)",
    d: "m0 0h3l1 4 5-3h9l5 4v25l-4 1-1-23-2-2h-7l-3 3-1 22-5-1z",
    fill: "#1C1F2E"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,271)",
    d: "m0 0 7 1 4 5v11l-5 5h-8l-4-5v-12z",
    fill: "#F1F0F2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,45)",
    d: "m0 0h7l5 4 6 2 8 11 3 15 1 2v20l-3 4h-3v7l-3 3-9 1-5 4h-7l-2-5 4 2 6-1 3-6 3 2 6-1 2-8 4-2v-7l-2-1 1-3h2l-3-16-2-3v-6l-7-10-7-2-4-3-5-1z",
    fill: "#2E3144"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(106,56)",
    d: "m0 0 2 1 2 5v7l-5-1-6-2 1 9h11l-1 5-1 1v15l1 1v5l-2 6-3-1-2-6-5-4-4-2v-6h6l3 6v2h2l1-18-7 2h-5l1-7 2-10 2-1h7z",
    fill: "#1D1F2C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(228,271)",
    d: "m0 0h6l5 4 1 2v10l-5 6h-8l-4-5v-12z",
    fill: "#F1F0F2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(227,336)",
    d: "m0 0h8l5 6v8l-2 5-4 3h-6l-4-4-1-2v-11z",
    fill: "#F3F2F3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1560,888)",
    d: "m0 0h5l-1 5-10 5-11 2h-20l-1-8h11l18-2z",
    fill: "#AB8598"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,271)",
    d: "m0 0h6l5 5v11l-3 5-2 1h-7l-3-3-2-4v-8l4-6z",
    fill: "#F2F1F3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,271)",
    d: "m0 0h6l5 4 1 3v7l-2 5-3 3h-8l-4-5v-11z",
    fill: "#EFEEF1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,993)",
    d: "m0 0h2l4 20v5l-7-1-11-5-2-1 1-6 5-7z",
    fill: "#6E7AA3"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(625,336)",
    d: "m0 0h8l5 6v10l-5 5-7 1-4-4-1-3v-10z",
    fill: "#EFEEF1"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,336)",
    d: "m0 0h7l5 5v12l-6 5h-6l-4-5-1-3v-7l3-5z",
    fill: "#F0EFF1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,331)",
    d: "m0 0h6l6 4 1 4-5-1-2-1h-7l-1 5 6 2 8 3 2 3v6l-3 4-5 2h-7l-5-3-2-2v-4l8 4h6l2-1v-5l-12-4-4-5 1-6 5-4z",
    fill: "#1C1F2C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(288,332)",
    d: "m0 0h9l5 3 1 5-4-1-3-2h-7l-1 5 5 2 9 3 2 4v6l-4 4-3 1h-9l-6-5 1-4 6 4 9-1v-5l-11-3-4-3v-9z",
    fill: "#181A26"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,267)",
    d: "m0 0h4v30h-4l-1-3-5 3-9-1-3-4-1-3v-21h5l1 22 2 2h6l4-4z",
    fill: "#161924"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(417,267)",
    d: "m0 0h6l6 4v4l-5-2-2-1h-6l-2 2 1 4 10 3 5 4 1 6-4 5-5 2h-6l-6-4-1-1v-5l3 1 3 3h8l2-2v-3l-9-3-6-3-1-2v-7l4-4z",
    fill: "#1B1D2A"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(387,271)",
    d: "m0 0 7 1 4 6v8l-4 6-1 1h-7l-4-4-1-3v-9l4-5z",
    fill: "#EFEFF2"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1519,80)",
    d: "m0 0h10l3 3v17l-1 1h-14l-3-4v-5l3-3 10-1-1-3-11 1 1-4z",
    fill: "#191C29"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(842,80)",
    d: "m0 0h9l3 3 1 3v14l-7 1h-8l-3-2v-8l6-3h7l-1-3-11 1 1-5z",
    fill: "#181B28"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1058,993)",
    d: "m0 0h9l6 2 4 3-2 6-11 14h-2l-4-16z",
    fill: "#6E7BA3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1238,80)",
    d: "m0 0h8l5 5v15l-4 1h-10l-3-1-1-2v-6l3-3 9-2v-2l-11 1 1-4z",
    fill: "#191D2A"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,336)",
    d: "m0 0h7l5 5v11l-6 5-7-1-4-6v-7l3-5z",
    fill: "#F0EFF1"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(198,331)",
    d: "m0 0h6l6 4 3 3v3l-5-1-3-3h-8l-3 3v12l2 4 2 1h6l6-5h2l-1 6-6 4h-8l-6-4-3-5v-11l2-5 6-5z",
    fill: "#1B1D2A"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(696,332)",
    d: "m0 0h10l5 3 2 3v3l-4-1-4-3h-7l-4 5v9l3 5 2 1h6l4-2v-2l4-1-1 6-4 3-3 1h-8l-6-5-3-9v-6l5-8z",
    fill: "#181B27"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(960,80)",
    d: "m0 0h7l4 4v16l-2 1h-12l-3-2v-8l2-2 10-1v-4l-12 3 2-5z",
    fill: "#141823"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(349,332)",
    d: "m0 0h10l5 4 1 5-4-1-4-3h-7l-3 3-1 3v7l2 6 9 1 6-5h2l-1 5-4 4-9 1-6-3-3-4-1-3v-12l6-7z",
    fill: "#151823"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(524,1112)",
    d: "m0 0h140v1h-139l1 1h9l1 4 6 1v1l-8 1-8 8h-2z",
    fill: "#575D92"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1044,1047)",
    d: "m0 0 5 1 12 5-3 4 8 8 1 8-4 1-5-5-4-6-6-1-4-12z",
    fill: "#6D7AA2"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(374,325)",
    d: "m0 0 5 1v6h6l-1 4h-5l1 20 5 2v4l-8-1-3-4v-21l-5-2 1-2 3-1z",
    fill: "#181C29"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(213,77)",
    d: "m0 0h14l3 3v8l-3 3-3 1h-11z",
    fill: "#F2F1F2"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(425,325)",
    d: "m0 0h4v7h6v4h-6l1 20 6 2v4l-8-1-4-5v-20l-4-1v-3l4-1z",
    fill: "#191C28"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(547,1135)",
    d: "m0 0 5 1 4-1h8l12 1 3 1v2l-7 2h-5l-1 1 8 1v1h-33l2-4z",
    fill: "#6E7AA4"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(774,260)",
    d: "m0 0 4 1v6h5l1 4h-6l1 21 5 1v5l-6-1-5-4v-22h-4l1-4 3-1z",
    fill: "#1A1C28"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(976,80)",
    d: "m0 0 7 1 1-1h7l3 5v16h-5l-1-16-6 1-1 15h-5z",
    fill: "#131621"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(190,258)",
    d: "m0 0h4v35h19v4h-23z",
    fill: "#0D0F15"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1501,77)",
    d: "m0 0 9 1 5 3h3l-3 5 7-2 5 1v3l-10 2-2 2v9l-4 1v-22h-6v20l-4 2z",
    fill: "#EFEEF0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1229,82)",
    d: "m0 0 1 2h3v3h5v-2l7-1v4l-9 2-2 2-1 8-4-1 1-6-7 4-5-1-2-2v-7l3-3h5l2 4h3z",
    fill: "#E6E4E9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1146,80)",
    d: "m0 0h5l1 16h5l1-1 1-15h5v20l-15 1-3-4z",
    fill: "#12151E"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1302,80)",
    d: "m0 0 7 1 1-1h7l3 3 1 18h-5l-2-16-6 1-1 15-5-1z",
    fill: "#171B28"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1329,80)",
    d: "m0 0h9l3 3v3l-10-1v2l11 4v7l-5 3h-9l-3-4v-3l6 2h5v-2l-9-3-2-1v-6z",
    fill: "#181B28"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,80)",
    d: "m0 0h9l3 3v3l-5-1-6-1v4l8 1 4 3v5l-4 4h-10l-3-3v-4l5 2h6v-2l-10-3-1-1v-6z",
    fill: "#161A26"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,630)",
    d: "m0 0h1v45l-5 5-1-1 1-9-2-13 1-13 2-4 2-1z",
    fill: "#6D7AA2"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(871,325)",
    d: "m0 0h4l1 6 6 2-1 3h-6l1 20 6 2v3h-7l-4-3v-22l-5-1v-3l4-1z",
    fill: "#141721"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1217,80)",
    d: "m0 0h8l4 3v5h-3l-2-3h-5l-2 2v7l2 2 6-1 2-2h3l-1 5-4 3h-8l-5-5-1-2v-8l4-5z",
    fill: "#161A26"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,322)",
    d: "m0 0h5v40h-5z",
    fill: "#21263A"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(906,80)",
    d: "m0 0h6l5 4v4l-4-1-2-2h-5l-1 1v9l1 1h5l3-3h3l-1 5-3 3h-9l-4-3-1-3v-9l4-5z",
    fill: "#161A26"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(251,267)",
    d: "m0 0h4v3l6-3h5v4l-6 2-3 2-1 22h-5z",
    fill: "#1B1E2D"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,1024)",
    d: "m0 0 2 4v5h-2l-1 3-5 5-9 13-2 5-1 1-1 4-2-5-3-3 1-2h2l1-4-1-7 9 1 2-5 8-10z",
    fill: "#6F7CA4"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1121,1024)",
    d: "m0 0 3 4v2l4 2 10 6 18 6 5 2v2h-9l-16-6-12-7-5-4 1-6z",
    fill: "#99A5C9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(825,729)",
    d: "m0 0h7v13l-1 8-1 1h-7l-1-5 2-16z",
    fill: "#D6DEE5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1314,294)",
    d: "m0 0h8l1 1 1 16-3 3h-8v-1l7-1 2-4-7 1-4-4v-8z",
    fill: "#424661"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 75)",
    d: "m0 0h4l1 4 3 1v4h-3l1 12 2 1v4h-6l-2-1-1-3v-13l-3-1 1-3 2-1z",
    fill: "#171A27"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1553,294)",
    d: "m0 0h6l3 3v10l-3 2h-5l-1-1-1 7h-2v-19z",
    fill: "#EDECEF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1241,294)",
    d: "m0 0h5l3 2v11l-2 2h-7l-1 5-2-1v-17z",
    fill: "#ECEAEC"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1146,677)",
    d: "m0 0 4 1 5 5 7 11v3h-11v-4h-2l-3-10z",
    fill: "#D4DDE5"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1129,994)",
    d: "m0 0h1l1 10 2 4 5 5 8 6 13 6 9 3v2h-7l-11-4-11-6-5-4-5-7z",
    fill: "#99A5C9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,83)",
    d: "m0 0h1v17l-3-2v-5l-5 3-1 1h-5l-2-2v-9l2-2h5l3 3 3 1 1-4z",
    fill: "#D6D5D9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,752)",
    d: "m0 0 8 1v21h-8z",
    fill: "#F9F9F9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,267)",
    d: "m0 0 4 1v2l6-3h5v4l-6 2-4 3-1 21h-4z",
    fill: "#14161F"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1361,327)",
    d: "m0 0h10l2 3v7l-4 4h-6v5h-2z",
    fill: "#505479"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1296,262)",
    d: "m0 0 7 1 2 1v10l-2 2h-8v5h-2v-18z",
    fill: "#56597E"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(505,332)",
    d: "m0 0 4 1h2l2-1h7v4l-8 2-2 1-1 23h-4z",
    fill: "#141720"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1225,290)",
    d: "m0 0h1v17l-3 2h-6l-3-4v-7l4-4h7z",
    fill: "#293046"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1257,75)",
    d: "m0 0h4l1 4 4 2-1 3h-3l1 12 3 2v3h-6l-3-3-1-12-2-3v-3l2-1z",
    fill: "#151824"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1396,258)",
    d: "m0 0h2v17l-1 1h-10l-1-2v-9l3-3 7 1z",
    fill: "#F2F1F2"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1058 1e3)",
    d: "m0 0 2 3 2 9v4h2l1 7 6 25-1 4-5-16-1-10h-2l-2-5-12-6-7-2-2 1 1-5 6 2 14 5-2-8z",
    fill: "#818BB8"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,332)",
    d: "m0 0h5v3l5-2-4 7-1 22-5-1z",
    fill: "#202333"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(877,75)",
    d: "m0 0h4l1 4 4 2-1 3h-3v13l4 1v3h-7l-2-2-1-16h-2l1-3h2z",
    fill: "#161926"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(119,44)",
    d: "m0 0h6v1l-5 1-2 4-1 43-1 2-1 10h-1v-55z",
    fill: "#2E3958"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1798,1035)",
    d: "m0 0h6l1 1v21l-4 1-3-1-1-21z",
    fill: "#D6DEE5"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1791,1159)",
    d: "m0 0h7l-1 15-2 6h-5l-1-1v-12l1-7z",
    fill: "#D6DEE5"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1405,262)",
    d: "m0 0h6l4 4v7l-4 4-7-1-2-5v-5z",
    fill: "#F2F1F2"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1532,1162)",
    d: "m0 0h5l1 2-10 5h-4v2l55 1v-5h1v6h-78v-1l14-1 13-8z",
    fill: "#AA8598"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1505,294)",
    d: "m0 0h5l2 2v11l-2 2h-6l-1-1-1 6h-1v-16z",
    fill: "#EBE9EC"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1218,262)",
    d: "m0 0 7 1 2 4v6l-3 3h-8l-2-4v-6z",
    fill: "#EFEEF0"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1655,294)",
    d: "m0 0 7 1 2 3-1 9-2 2h-6l-3-3v-9z",
    fill: "#EDECEE"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1478,294)",
    d: "m0 0 7 1 2 3v7l-4 4h-6l-2-4v-8z",
    fill: "#EFECEE"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,1033)",
    d: "m0 0h3l3 24v7l-5 5-1-2 1-4-1-2-1-8 1-5-1-5 1-6-2-1z",
    fill: "#585F93"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(649,332)",
    d: "m0 0h5v30l-5-1z",
    fill: "#1A1E2C"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(603,332)",
    d: "m0 0h5v30l-5-1z",
    fill: "#1F2538"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1339,294)",
    d: "m0 0h5l3 3v9l-2 3h-6l-4-4v-6z",
    fill: "#E7E4E6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1775,294)",
    d: "m0 0h5l3 5v8l-2 2h-7l-3-6v-5z",
    fill: "#F0EFEF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1533,262)",
    d: "m0 0 7 1 3 4-1 7-2 2h-7l-3-3v-7z",
    fill: "#F2F0F1"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(821,771)",
    d: "m0 0h7l-2 20-3 1-4-1v-9l1-10z",
    fill: "#D6DEE5"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1520,294)",
    d: "m0 0h6l3 3-1 10-2 2h-6l-3-4 1-8z",
    fill: "#E8E6EA"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1113,1050)",
    d: "m0 0 5 2 10 6 15 6 8 2-2 3-14-3-11-5-11-6z",
    fill: "#9AA6CA"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1243,262)",
    d: "m0 0 7 1 2 3v7l-2 3h-8l-2-2v-8z",
    fill: "#D7D2DA"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1373,262)",
    d: "m0 0 7 1 2 2v8l-3 3h-7l-2-2v-9z",
    fill: "#EFEFF2"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1796,1118)",
    d: "m0 0h6v12l-1 9h-7l1-20z",
    fill: "#DAE1E7"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1797,1077)",
    d: "m0 0h7v21l-7-1z",
    fill: "#D6DEE5"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1247,327)",
    d: "m0 0h7l3 3v7l-3 4h-6l-3-3v-8z",
    fill: "#F1F0F1"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1531,1153)",
    d: "m0 0 5 1v2l-16 8-7 3-9 3 1-3 10-7 10-5z",
    fill: "#AB8598"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1074,1072)",
    d: "m0 0 2 4 3 11-1 3-3-1-1 4-6-1-7-5-1 2-3-9 9 3 10 4v-2l-5-1 3-1z",
    fill: "#6E7BA3"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,284)",
    d: "m0 0h20l-1 4h-2l-1 3-4 2h-8l-3-3z",
    fill: "#F5F4F4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1477,263)",
    d: "m0 0h8l2 3v7l-1 3h-10l-1-2v-8z",
    fill: "#E5E3E6"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1282,866)",
    d: "m0 0 29 1 1 3-3 1-11 1h-9l-11-2v-3z",
    fill: "#D6DEE5"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1661,262)",
    d: "m0 0 6 1 3 4-1 8-1 1h-9l-1-2v-8z",
    fill: "#86879A"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1142,991)",
    d: "m0 0 9 6 8 5 12 5 2-4v6l-1 2-12-3-11-6-7-6-1-4z",
    fill: "#9AA6CA"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1192,73)",
    d: "m0 0h5v28h-5z",
    fill: "#141924"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,853)",
    d: "m0 0h6l-1 11-2 10h-6l1-14z",
    fill: "#D6DEE5"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(455,737)",
    d: "m0 0h12l20 4 2 2v3l-9-1-23-5-2-1z",
    fill: "#D6DEE5"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(817,812)",
    d: "m0 0h6l1 2-2 18-5 1-2-1 1-18z",
    fill: "#D6DEE5"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(986,550)",
    d: "m0 0 16 2 13 4 1 4-8-1-23-5-1-3z",
    fill: "#D6DEE5"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1602,294)",
    d: "m0 0 5 1 2 2v9l-2 3h-6l-3-3v-8z",
    fill: "#84899F"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1616,294)",
    d: "m0 0h6l2 3v10l-2 2h-7l-1-2v-11z",
    fill: "#E5E3E7"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1579,262)",
    d: "m0 0 7 1 1 1v11l-1 1h-8l-2-3v-7z",
    fill: "#D1C9D2"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1572,714)",
    d: "m0 0h12l20 4 2 1-1 3-13-1-18-4-2-1z",
    fill: "#D6DEE5"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,690)",
    d: "m0 0 4 1-2 17-1 1h-7l1-10 1-8z",
    fill: "#D6DEE5"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1790,953)",
    d: "m0 0 5 1 3 17v4h-5l-2-2-3-19z",
    fill: "#D6DEE5"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,80)",
    d: "m0 0h11l1 4-6 2-1 15h-5z",
    fill: "#181D2B"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1044,570)",
    d: "m0 0 7 1 11 7 7 6-1 3-4-1-18-11-3-2z",
    fill: "#D7DFE6"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(513,982)",
    d: "m0 0h2l1 3v10l-4 8-5 1-1-3 2-9 2-5 1-3h2z",
    fill: "#575D92"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(888,76)",
    d: "m0 0 3 1v2h-2v21h-2v-3h-5v-13l3-1v-2l-3-1 1-3z",
    fill: "#F7F6F6"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(106,44)",
    d: "m0 0h7l1 5-7-1-4 2v2l-7 1-3 6-3 3v7l-2 3-1 5h-1l-1-9 2-8 3-3 3-5 5-3 5-2z",
    fill: "#25293C"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1229,1136)",
    d: "m0 0h2l6 21 3 12v9l-3-4-2-7-6-24z",
    fill: "#D1DAE3"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1120,639)",
    d: "m0 0 5 2 5 5 6 9-1 4-4-1-7-8-5-7z",
    fill: "#D6DEE5"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1717,796)",
    d: "m0 0h5l12 12 2 3-1 5-4-2-8-8-4-5v-2h-2z",
    fill: "#D6DEE5"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1682,761)",
    d: "m0 0 6 1 12 9 3 4-1 4h-3l-12-11-5-5z",
    fill: "#D6DEE5"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(294,1158)",
    d: "m0 0 4 1 7 15 1 3-4 1-3-1-7-15v-3z",
    fill: "#D6DEE5"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(739,914)",
    d: "m0 0 7 1 15 5 9 2v3h-9l-18-6-4-2z",
    fill: "#D6DEE5"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,550)",
    d: "m0 0 5 1v2l-12 3-15 3h-5l1-4 18-4z",
    fill: "#D6DEE5"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1505,80)",
    d: "m0 0h6v21h-5l-1-1z",
    fill: "#252838"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1746,833)",
    d: "m0 0 4 2 6 9 3 5v4h-4v-2l-4-2-8-13v-2z",
    fill: "#D9E0E6"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(280,1118)",
    d: "m0 0 3 1 6 16v4l-5-1-5-10-2-9z",
    fill: "#D6DEE5"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(259,1036)",
    d: "m0 0h6l1 22-5-1-1-1-1-11z",
    fill: "#D6DEE5"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(889,80)",
    d: "m0 0h6v21h-5l-1-4z",
    fill: "#24283D"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(804,893)",
    d: "m0 0 4 1-3 9-7 10-5 1v-3l8-14z",
    fill: "#D6DEE5"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1435,770)",
    d: "m0 0 4 1-3 5-11 9-7 5-2-4 12-11z",
    fill: "#D6DEE5"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1087,603)",
    d: "m0 0 5 1 11 10 4 4-1 3-5-1-7-6v-2h-2v-2l-3-1-2-3z",
    fill: "#D6DEE5"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1269,80)",
    d: "m0 0h6v20l-5 1-1-4z",
    fill: "#252839"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,332)",
    d: "m0 0h4v30h-4z",
    fill: "#0E1118"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(749,271)",
    d: "m0 0h6l5 6v3h-17l1-5z",
    fill: "#E7E6EA"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(279,271)",
    d: "m0 0h6l5 5v4h-16l1-5z",
    fill: "#E8E6E9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,348)",
    d: "m0 0h9v7l-6 3-7-1-1-1v-5z",
    fill: "#EAEAED"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(526,1114)",
    d: "m0 0h9l1 4 6 1v1l-8 1-8 8h-2v-10h2z",
    fill: "#545C8C"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1359,838)",
    d: "m0 0h2l-1 4-11 9-8 5h-4l1-4 17-12z",
    fill: "#D6DEE5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1058,993)",
    d: "m0 0h9l6 2 4 3-2 5h-7l-3-3-2-3h-5z",
    fill: "#5A6194"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1635,730)",
    d: "m0 0 9 3 10 5v2l6 2v4l-4-1-21-11z",
    fill: "#D7DEE5"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(856,332)",
    d: "m0 0h4v29h-4z",
    fill: "#0D0F15"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,283)",
    d: "m0 0h6l-1 7-4 3h-8l-1-1v-7z",
    fill: "#EDEBEE"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(364,268)",
    d: "m0 0h4v29h-4z",
    fill: "#0D0F15"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1229,82)",
    d: "m0 0 1 2h3v3h5v-2l7-1v4l-9 2-2 2-1 8-4-1 1-6h-3l-1-5h3z",
    fill: "#E7E5E9"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1396,805)",
    d: "m0 0h4l-1 4-11 9-7 6-3-1 1-4 14-12z",
    fill: "#D6DEE5"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1202,294)",
    d: "m0 0 7 1 1 1v12l-1 1h-9l-1-7 5-2 4-1-1-2-5-1-1 2z",
    fill: "#4D5376"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(148,95)",
    d: "m0 0h2l-1 6-2 2h-3v7l-3 3-9 1-5 4h-7l-2-5 4 2 6-1 3-6 3 2 6-1 2-8 5-3z",
    fill: "#171A26"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(660,81)",
    d: "m0 0h7l2 2v18h-5l-1-16-5-1z",
    fill: "#131721"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1131,1092)",
    d: "m0 0h3l-1 5-3 4h-19l5-4 4-1z",
    fill: "#7A85B0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1257,262)",
    d: "m0 0h17v15h-2v-13h-6v13h-2v-12l-6-1v13h-2v-14z",
    fill: "#454B70"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1109,1073)",
    d: "m0 0 14 8 11 5 4 1-2 4-12-5-16-8z",
    fill: "#9AA6CA"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1330,327)",
    d: "m0 0h19v14h-2v-12h-7v12h-2v-12h-6v12h-2z",
    fill: "#5E5B7D"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(260,994)",
    d: "m0 0 2 4v18l-4 1-2-6v-15z",
    fill: "#D6DEE5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(414,739)",
    d: "m0 0h10l-4 3-20 6-9 1 4-4 14-5z",
    fill: "#D6DEE5"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1424,294)",
    d: "m0 0h5l3 3v11l-2 1h-7l-2-2 1-4 3-1v-2l5-1-1-2h-5l-2 1z",
    fill: "#4C5172"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,993)",
    d: "m0 0h2v8h-3l-1 2-5 3-3 3h-3l1-6 4-5z",
    fill: "#5B6296"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(399,336)",
    d: "m0 0h8l4 4v4h-16l1-5z",
    fill: "#F2F1F2"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(319,336)",
    d: "m0 0h8l3 3v5h-16l1-4z",
    fill: "#F1F0F2"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1202,80)",
    d: "m0 0h6l-1 21h-5z",
    fill: "#1A1E2D"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1478,739)",
    d: "m0 0h3l-1 5-18 11-4 1-1-2 4-4z",
    fill: "#D6DEE5"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(820,336)",
    d: "m0 0h8l4 5v3h-16l1-5z",
    fill: "#F1F0F2"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(481,336)",
    d: "m0 0h8l4 4v4h-16l1-5z",
    fill: "#F2F0F2"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(950,83)",
    d: "m0 0 4 1v3l7-3h5v4l-10 2-1 1-1 9-4-2z",
    fill: "#E2E0E6"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(268,1077)",
    d: "m0 0 4 1 4 16v4h-5l-3-10-1-10z",
    fill: "#D6DEE5"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(366,762)",
    d: "m0 0h2l-2 4-14 12-4 3h-3l2-5 10-9z",
    fill: "#D6DEE5"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1176,84)",
    d: "m0 0h5l2 2v9l-2 2h-5l-2-2v-9z",
    fill: "#D4D3D9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1286,84)",
    d: "m0 0h5l2 2v9l-2 2h-5l-2-2v-9z",
    fill: "#EAEAED"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(921,80)",
    d: "m0 0h5v21h-5z",
    fill: "#151926"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(327,797)",
    d: "m0 0h4l-2 4-9 11-3 4h-4l1-5 9-10z",
    fill: "#D6DEE5"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1312,262)",
    d: "m0 0h6l1 4h-2v-2h-5v4l6 1 1 1v6h-9l-1-2v-10z",
    fill: "#DEDADF"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(938,84)",
    d: "m0 0h5l2 2v8l-2 3h-5l-2-2v-9z",
    fill: "#D2D1D7"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1764,873)",
    d: "m0 0 5 1 4 6 3 10-1 4-4-4v-3h-2l-5-11z",
    fill: "#D6DEE5"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(301,833)",
    d: "m0 0 2 1-1 5-9 14-2 2h-3l1-5 8-13z",
    fill: "#D6DEE5"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,78)",
    d: "m0 0 3 1h7l-5 6v15l-4 1-1-1z",
    fill: "#F0EEF0"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1269,327)",
    d: "m0 0h11l1 11h6l1-10h2v11l-3 2h-7l-2-7v-5h-7v12h-2z",
    fill: "#676686"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,84)",
    d: "m0 0h5l2 2v8l-3 3-5-1-1-2v-8z",
    fill: "#EDEDF1"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(258,954)",
    d: "m0 0h4v14l-1 7-2 1-3-2 1-19z",
    fill: "#D6DEE5"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1488,84)",
    d: "m0 0h5l2 2v8l-3 3h-4l-2-3v-8z",
    fill: "#EDEAED"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,964)",
    d: "m0 0h16l9 4-3 1-6-2-4 3v-2l-7 1-1 2-5-3-2-1-4 1 3-3z",
    fill: "#5C6496"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1437,327)",
    d: "m0 0h8l1 1v13h-9v-8h7v-4h-7z",
    fill: "#4A4F73"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1512,814)",
    d: "m0 0 2 2-6 11-5 5v2l7 1h3v3l-8 1-6-5v-3l5-4z",
    fill: "#AB7D9B"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1198,76)",
    d: "m0 0h3l1 2 3 1h-3v19l-2 3h-2z",
    fill: "#F6F6F6"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1796,995)",
    d: "m0 0h5l1 21-5-1z",
    fill: "#F9F9F9"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1593,824)",
    d: "m0 0 8 1 2 3-1 4-7 4h-2l-1 5-3-1 2-5 5-4 3-1 1-2-5-1-1 3-5-2v-3z",
    fill: "#AB8598"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,724)",
    d: "m0 0h10l5 3 4 5v5l-8-8-9-2-9 6 1-5z",
    fill: "#5B6296"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1263,294)",
    d: "m0 0h5l2 2v11l-2 2h-6l-2-4 4 2h3l1-3-5-2-2-2 1-5z",
    fill: "#9FA0AF"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,1024)",
    d: "m0 0 2 4v5h-2l-1 3-5 5-10 14-1-3 8-12 4-7 4-6z",
    fill: "#7B86B2"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1006,85)",
    d: "m0 0h1l1 10 3 1v-7l9 3 5 2-1 3h-6l-5-3v6l-3 1-1-3-3-2z",
    fill: "#DDDAE1"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,78)",
    d: "m0 0h8l2 2v6l-3 2h-7z",
    fill: "#B6B2C0"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1620,262)",
    d: "m0 0 6 1 2 2-1 5-1 1h-8l-1 3-1-7z",
    fill: "#9392A4"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,45)",
    d: "m0 0h7l5 4 6 2 7 10-1 4-7-9-2-3-7-2-4-3-5-1z",
    fill: "#151824"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1587,1150)",
    d: "m0 0 3 2 1 9-3 6-3 1-2-4 2-5-1-7z",
    fill: "#AD6AA5"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(835,80)",
    d: "m0 0 3 1v5l6-2h5l1 4-9 2-4 2-2 3-1-5h-2z",
    fill: "#F2F3F5"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(266,913)",
    d: "m0 0h2l-1 12-1 10h-5l-1-2 4-17z",
    fill: "#D6DEE5"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1586,849)",
    d: "m0 0 4 2-2 6-8 14-7 9v-3l8-15z",
    fill: "#AA869A"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1315,296)",
    d: "m0 0h6l1 1v8l-3 2-5-1-1-1v-7z",
    fill: "#EDEDF0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(106,56)",
    d: "m0 0 2 1 2 5v7l-5-1-6-2v8h-3l1-10 2-1h7z",
    fill: "#242737"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(279,873)",
    d: "m0 0h3l-1 4-3 7-3 10-2 1-2-1 1-6 6-14z",
    fill: "#DCE3E8"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1095,1093)",
    d: "m0 0 2 3v6h-12l-1-5 3-2h8z",
    fill: "#575D92"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(891,572)",
    d: "m0 0h4l-2 5h-2l-1 3-8 6-1-7 8-6z",
    fill: "#D5DDE5"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1553,294)",
    d: "m0 0h6l3 3v10l-3 2h-5l-1-1-1 7h-2v-19zm0 2-1 1v9l3 2 4-1 2-2v-7l-2-2z",
    fill: "#5A5D84"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1218,296)",
    d: "m0 0h6v10l-1 1h-6l-1-2v-7z",
    fill: "#F5F5F6"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1396,258)",
    d: "m0 0h2v17l-1 1h-10l-1-2v-9l3-3 7 1zm-7 6-1 1v9l1 1h5l2-2v-8l-1-1z",
    fill: "#5F618A"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1241,294)",
    d: "m0 0h5l3 2v11l-2 2h-7l-1 5-2-1v-17zm-1 2-1 1v8l3 3 5-1 1-1v-8l-2-2z",
    fill: "#4B506F"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(84,72)",
    d: "m0 0h2v7l-1 7 2 3-1 4-2 5-3 1 1-11-1-6z",
    fill: "#222537"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1780,914)",
    d: "m0 0 4 1 2 5 2 11v4l-3-1-3-8z",
    fill: "#F9F9F9"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(719,981)",
    d: "m0 0 2 1 2 7v13l-2 7-4-2-1-4h2l1-6 1-11z",
    fill: "#636B9C"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1295,264)",
    d: "m0 0h7l1 1v9h-8z",
    fill: "#F5F4F5"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1127,78)",
    d: "m0 0h8l1 1v7l-1 1h-8z",
    fill: "#DBD9DA"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1363,329)",
    d: "m0 0h8v8l-1 2h-7z",
    fill: "#F6F5F5"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1454,262)",
    d: "m0 0h14l2 2v12h-1l-1-12h-6v12h-2l-1-11h-5l-1 11h-1v-12z",
    fill: "#454D6D"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1501,77)",
    d: "m0 0h1l1 6h2v17l-4 2z",
    fill: "#F9F9F9"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(993,81)",
    d: "m0 0h4l3 3v14l-2-4h-2v5h-1v-14h-2z",
    fill: "#EEEEF0"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1083,1069)",
    d: "m0 0h5l1 4-7 8-3 1 1-8z",
    fill: "#585F93"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1706,294)",
    d: "m0 0 5 1 1 1v12l-1 1h-8l-1-6 2-3 3 1-3 6h6v-11l-7 2v-3z",
    fill: "#4D5073"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1520,294)",
    d: "m0 0h6l3 3-1 10-2 2h-6l-3-4 1-8zm1 2-2 2v7l2 3 5-1 1-5-2-1-3 1v-2h5l-1-4z",
    fill: "#5A5B7D"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1405,262)",
    d: "m0 0h6l4 4v7l-4 4-7-1-2-5v-5zm1 2-2 2v7l2 2h5l2-2v-7l-2-2z",
    fill: "#66617F"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,50)",
    d: "m0 0h1l1 63-2 2-1-4z",
    fill: "#A690A6"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1421,327)",
    d: "m0 0h9l2 2v12h-2v-12h-8v12h-2v-13z",
    fill: "#716C91"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1616,294)",
    d: "m0 0h6l2 3v10l-2 2h-7l-1-7 2-1 1 6h5v-7l-4 2 1-3h2v-3l-6 1z",
    fill: "#50526E"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1576,294)",
    d: "m0 0h5l3 5v7l-3 3h-6l-2-2v-5h3v-2h3l-1 3h-3l1 4 5-1v-9l-7 1z",
    fill: "#444868"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1590,1153)",
    d: "m0 0h2l2 7v10l-3 1-5-2 4-8z",
    fill: "#575D92"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1638,294)",
    d: "m0 0h6l4 4v10h-2l-1-10-1-1h-5l-1 12h-2v-12z",
    fill: "#53587E"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(895,82)",
    d: "m0 0 4 2 1 15h-5z",
    fill: "#EBEAED"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,54)",
    d: "m0 0h3l-1 5-3 3v7l-2 3-1 5h-1l-1-9 2-8 3-3z",
    fill: "#292A3B"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1314,327)",
    d: "m0 0h2v12h7v-12h2v13l-1 1h-8l-2-3z",
    fill: "#4D5279"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1218,262)",
    d: "m0 0 7 1 2 4v6l-3 3h-8l-2-4v-6zm0 2-2 2v7l2 2h5l2-2v-7l-2-2z",
    fill: "#484D6F"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1533,262)",
    d: "m0 0 7 1 3 4-1 7-2 2h-7l-3-3v-7zm1 2-2 2v7l2 2 6-1 1-1v-6l-2-3z",
    fill: "#2F3550"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,84)",
    d: "m0 0h3v10l3 5-1 2-2-1-4 1v-16z",
    fill: "#F0F1F3"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1505,294)",
    d: "m0 0h5l2 2v11l-2 2h-6l-1-1-1 6h-1v-16zm-1 2-2 3v5l4 4 5-2v-9l-1-1z",
    fill: "#42496A"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(882,84)",
    d: "m0 0 5 1 1 5-1 6-5 1z",
    fill: "#D9D8DB"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(638,81)",
    d: "m0 0 2 2v17l-4-2v-14h2z",
    fill: "#F0EEF0"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1251,841)",
    d: "m0 0 5 5 1 5h-8l-2-3 2-6z",
    fill: "#D5DDE5"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1565,262)",
    d: "m0 0 6 1-1 3-5-1-1 9h5l1-2h-3l-1-4 5 1 1 6-1 1h-8l-1-1v-10z",
    fill: "#5B5C76"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1477,263)",
    d: "m0 0h8l1 1v6l-7 1 1-3h5v-3h-7v9h7v2h-9l-1-2v-8z",
    fill: "#4C4E6E"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1522,838)",
    d: "m0 0h2l-1 4-5 3-4 1h-10v-3l11-1 6-3z",
    fill: "#AB8398"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1247,327)",
    d: "m0 0h7l3 3v7l-3 4h-6l-3-3v-8zm1 2-2 2 1 7 2 2 5-1 1-1v-8l-1-1z",
    fill: "#4A5072"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1577,296)",
    d: "m0 0 5 1v9l-3 2-4-1v-4l3-1 1-2h-3z",
    fill: "#E8E7EA"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1478,294)",
    d: "m0 0 7 1 2 3v7l-4 4h-6l-2-4v-8zm0 2-2 2v7l3 3 4-1 2-2v-7l-2-2z",
    fill: "#484C6C"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(116,93)",
    d: "m0 0h1v18l-3 5-2 2-3-1 4-5 2-17z",
    fill: "#161B28"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1455,84)",
    d: "m0 0h4l1 15-5 1z",
    fill: "#EDECEE"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1300,82)",
    d: "m0 0 2 1v15h-5l1-14z",
    fill: "#EDEBEE"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1655,294)",
    d: "m0 0 7 1 2 3-1 9-2 2h-6l-2-2 1-3 2 3 4-1 1-1v-7l-1-1h-5l-2 6h-1v-6z",
    fill: "#4D5070"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(793,291)",
    d: "m0 0h4l-1 9-2 6h-3v-7z",
    fill: "#181A26"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1223,327)",
    d: "m0 0h7v2h-6l1 3 6 2v5l-2 2h-6l-1-2h7v-4h-5l-2-3z",
    fill: "#575A7D"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1377,327)",
    d: "m0 0h2v12h7v-12h2v13l-1 1h-9z",
    fill: "#3E4262"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1373,262)",
    d: "m0 0 7 1 2 2v8l-3 3h-7l-2-2v-9zm0 2-2 2v7l2 2 7-1v-8l-2-2z",
    fill: "#3A4466"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1243,262)",
    d: "m0 0 7 1 1 1v7h-7l1-3 5 1-2-4h-6v8l1 1h7v2h-8l-2-2v-8z",
    fill: "#424463"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1579,262)",
    d: "m0 0 7 1 1 1v5l-7 2v-3h5l-1-3-5-1-1 8 1 2h7v2h-8l-2-3v-7z",
    fill: "#383E5A"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1190,79)",
    d: "m0 0h1v21l-3-2-1-12-1-5 3 1z",
    fill: "#E5E5EB"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1726,294)",
    d: "m0 0h8l1 2v12h-1l-1-12-6 1-1 12h-2v-12z",
    fill: "#4C4F71"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1265,83)",
    d: "m0 0 2 1v12h-5v-12z",
    fill: "#D5D3D5"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1741,295)",
    d: "m0 0h1l2 12 4-1 1-11h2v13l-1 1h-8l-1-1z",
    fill: "#494C6F"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1775,294)",
    d: "m0 0h5l2 4-7-1-1 1v9l9-2-2 4h-7l-3-6v-5z",
    fill: "#5E5D7E"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1333,262)",
    d: "m0 0h2v13l-1 1h-9l-1-1v-12h1l1 10 7 1z",
    fill: "#4C4F70"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,83)",
    d: "m0 0h2v6h-2v7l-4-1v-10z",
    fill: "#D7D6D9"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1468,1138)",
    d: "m0 0 2 1 2 5 4 17v6l-2-2-5-19z",
    fill: "#191E2E"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1031,1073)",
    d: "m0 0 4 5 9 14 4 6h-3l-11-16-3-6z",
    fill: "#7E89B4"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1199,321)",
    d: "m0 0h3l-1 25h-3z",
    fill: "#73708F"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1208,83)",
    d: "m0 0 4 1v10l1 5-5-1z",
    fill: "#F3F3F4"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1062,1022)",
    d: "m0 0h2l7 28-1 4-5-16z",
    fill: "#96A1C7"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1330,327)",
    d: "m0 0h19v14h-2v-12l-17-1z",
    fill: "#7B7B9D"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1670,294)",
    d: "m0 0h6l1 4-6-2 1 4 6 4-1 4-1 1h-6v-3l6 1-1-3-6-4v-5z",
    fill: "#4B4D6D"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1299,294)",
    d: "m0 0h6l2 2v13h-1l-2-12h-5l-1 1v11h-2v-14z",
    fill: "#414765"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1275,82)",
    d: "m0 0 2 4 1 1 2 9 1 4-6-1z",
    fill: "#F6F6F7"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1480,84)",
    d: "m0 0h1l1 15-5-1 1-13z",
    fill: "#EBE7EA"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(857,81)",
    d: "m0 0 2 1v18l-4-2v-14z",
    fill: "#F9F9F9"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1206,327)",
    d: "m0 0h2v12l6-1 1-10h1v11l-2 2h-7l-1-1z",
    fill: "#40476A"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1759,294)",
    d: "m0 0 7 1 2 6v7h-2l-1-10-7-2-1 12h-1v-13z",
    fill: "#4C506F"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1595,262)",
    d: "m0 0 7 1v2h-7l-1 1v7l5 1 4-1-1 3h-8l-3-4v-6z",
    fill: "#484B6A"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,84)",
    d: "m0 0h4v11l-3-2-1 7h-1v-15z",
    fill: "#F0F0F3"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(974,81)",
    d: "m0 0h1v19l-3 1v-16z",
    fill: "#F8F8F8"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1056,1077)",
    d: "m0 0 10 3 5 2v2l5 1v2l-10-3-10-4z",
    fill: "#8C97C0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1044,1047)",
    d: "m0 0 5 1 3 3-2 5-2 2-3-5z",
    fill: "#5D6497"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1521,803)",
    d: "m0 0 11 2 6 4 1 3-4-1-8-4-6-1z",
    fill: "#A78298"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(99,109)",
    d: "m0 0 3 1 2 4 6 2v3h-5l-6-5-3-1v-3z",
    fill: "#2A2D40"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(131,108)",
    d: "m0 0 4 3v2l-5 3-3 2h-7l-2-5 4 2 6-1z",
    fill: "#1C212F"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1267,81)",
    d: "m0 0h2v20l-6-4v-2h3v-12z",
    fill: "#F0F0F1"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(659,84)",
    d: "m0 0h4v9h-4v6h-1v-14z",
    fill: "#F3F3F4"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1250,82)",
    d: "m0 0 2 4h4v12l-2-4h-3z",
    fill: "#F8F8F8"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1437,263)",
    d: "m0 0h8l2 3v9l-1 1h-9v-6l1-1h5l-4 2-1 4 7-2-1-8h-7z",
    fill: "#293047"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1257,262)",
    d: "m0 0h17v15h-2v-13l-15-1z",
    fill: "#79748E"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(929,80)",
    d: "m0 0h1v23h-1l-1-10h-2v-11z",
    fill: "#F0F0F0"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1436,81)",
    d: "m0 0 4 2 4-2-1 7-2 4-3-1z",
    fill: "#E0E1E8"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1449,1067)",
    d: "m0 0 2 1 5 19v6l-2-3-5-18z",
    fill: "#171C2A"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1071,1056)",
    d: "m0 0 2 3 3 9 3 15 1 2-3-1-6-24z",
    fill: "#96A2C7"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1424,296)",
    d: "m0 0h5l1 3-5 1v2l-5 4v-7l2-2z",
    fill: "#E0DFE4"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1439,268)",
    d: "m0 0h6l1 5-2 2h-6z",
    fill: "#D3D3DD"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1056,1022)",
    d: "m0 0 5 1 2 5v4h-2v-2l-3-1-3-4z",
    fill: "#575D92"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1278,616)",
    d: "m0 0 14 2-4 4-7-1z",
    fill: "#6D7AA2"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1096,1066)",
    d: "m0 0h1v7l-1 4h-6l1-4z",
    fill: "#5C6396"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1599,830)",
    d: "m0 0h3l-1 3-6 3h-2l-1 5-3-1 2-5 5-4z",
    fill: "#A77C9B"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1244,264)",
    d: "m0 0 5 1 1 4h-5l-1 2h-2l-1 2v-6z",
    fill: "#E1DFE5"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,92)",
    d: "m0 0h10l-2 4-1 1h-6z",
    fill: "#DDD8DE"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1325,91)",
    d: "m0 0 6 1 6 2-1 3-7-1-4-3z",
    fill: "#E8E5E8"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(837,83)",
    d: "m0 0 1 3 6-2h5l1 4-11 2 1-2-3-1z",
    fill: "#CCCCD7"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,83)",
    d: "m0 0h1v17l-3-2v-14z",
    fill: "#F5F4F4"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1501,832)",
    d: "m0 0 5 3h7v3l-8 1-6-5z",
    fill: "#AB8598"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1218,294)",
    d: "m0 0h7v11h-1v-9l-7 2-2 7h-1v-7z",
    fill: "#807692"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1470,92)",
    d: "m0 0h6l-4 5h-6l-2-4z",
    fill: "#E3E1E6"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1084,1037)",
    d: "m0 0 1 2-6 9-5 7-1-3 8-12h2z",
    fill: "#8A95C0"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(862,632)",
    d: "m0 0h2v5l-10 1-2-3 1-1 8-1z",
    fill: "#6D7AA2"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1438,294)",
    d: "m0 0h7v2l-6 1-1 12h-2v-11z",
    fill: "#535476"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(94,89)",
    d: "m0 0h6l1 4-3 3-4-1z",
    fill: "#3A3E52"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1142,78)",
    d: "m0 0h1v5h2v10l-1-2h-5l2-5z",
    fill: "#F2F0F2"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,1051)",
    d: "m0 0 4 1 1 4-2 4-1 4-2-5-3-3 1-2h2z",
    fill: "#7B86B2"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,724)",
    d: "m0 0h10v1l-7 1-9 7-1-3 5-5z",
    fill: "#646C9D"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(890,355)",
    d: "m0 0 5 1-1 5-4 1-2-2 1-4z",
    fill: "#22273A"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1608,259)",
    d: "m0 0 2 1 1 14 1 3-4-1z",
    fill: "#373D59"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1420,262)",
    d: "m0 0h5v2l-4 1v12h-2v-14z",
    fill: "#595776"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1661,264)",
    d: "m0 0h5l2 5h-6v2h-2v-6z",
    fill: "#E8E5E9"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1075 1e3)",
    d: "m0 0h2l-2 4-10 14-1-3z",
    fill: "#929EC5"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1439,334)",
    d: "m0 0h6v5l-6 1-1-5z",
    fill: "#DDDDE3"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1451,327)",
    d: "m0 0h7v2h-5v12h-2z",
    fill: "#737195"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1589,293)",
    d: "m0 0h4v2h-2l2 14h-3l-1-3z",
    fill: "#3F415A"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1564,265)",
    d: "m0 0 1 2 3 1h-2l1 4h3l-1 3h-5l-1-1z",
    fill: "#E6E5E9"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,84)",
    d: "m0 0h6l5 4-7 1-4-1z",
    fill: "#DDDDE5"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,45)",
    d: "m0 0h7l5 4 1 3-5-1-4-3-5-1z",
    fill: "#1A1F2F"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1049,1047)",
    d: "m0 0 9 3 9 4 1 2-5-1-14-6z",
    fill: "#95A1C7"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1337,296)",
    d: "m0 0h1v9l2 2 4-1 2-1-1 4h-6l-4-4v-6z",
    fill: "#3E4362"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1669,300)",
    d: "m0 0 7 4v3l-4 1-4-1z",
    fill: "#E1DFE5"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1707,299)",
    d: "m0 0h3v8h-6l1-4z",
    fill: "#EBECEE"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1339,294)",
    d: "m0 0h5l2 2v6l-7 1 1-3h4l-1-3-5-1z",
    fill: "#646382"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(961,92)",
    d: "m0 0h6l-1 4-1 1h-6v-4z",
    fill: "#D7D6DF"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,1082)",
    d: "m0 0v3l-1 5 3 11h-2l-2-3-2-13z",
    fill: "#A3AFCF"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1428,300)",
    d: "m0 0h2v7h-7l1-4z",
    fill: "#F1F0F2"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,92)",
    d: "m0 0h5l-1 4-1 1h-6v-4z",
    fill: "#E0DBE1"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(820,78)",
    d: "m0 0h7l1 4-2-1-3 1-2 4 3 1h-4z",
    fill: "#F7F6F6"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1295,324)",
    d: "m0 0h2l1 4v12h-3z",
    fill: "#474C6F"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1232,262)",
    d: "m0 0h5v2h-4v12h-2v-13z",
    fill: "#52557B"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1522,92)",
    d: "m0 0h5l-1 5h-6l-1-4z",
    fill: "#E7E3E6"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1241,92)",
    d: "m0 0h5v4l-2 1h-6v-4z",
    fill: "#E7E1E4"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(148,86)",
    d: "m0 0h2v9h-2l-1 3-1-6-2-1 1-3z",
    fill: "#272D42"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1324,83)",
    d: "m0 0h1v7l-3 1v7h-1v-14z",
    fill: "#F5F5F5"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(948,1171)",
    d: "m0 0 2 3 1 9h-4v-11z",
    fill: "#D0D8E2"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(532,762)",
    d: "m0 0 6 2 7 4v1l-7-1-6-3z",
    fill: "#F9F9F9"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(719,321)",
    d: "m0 0h5l1 1v5h-5l-1-1z",
    fill: "#2B2D40"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1206,300)",
    d: "m0 0 2 1v6h-7v-3z",
    fill: "#ECEBEC"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1671,296)",
    d: "m0 0 7 1-1 6-6-3z",
    fill: "#E5E5E8"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1478,264)",
    d: "m0 0 7 1v3l-5 1-2 2-1-6z",
    fill: "#EDEAEB"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(145,62)",
    d: "m0 0h1l1 13-3-3-2-3 1-5z",
    fill: "#292F46"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,999)",
    d: "m0 0h1l2 22h-3z",
    fill: "#7982AF"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(483,849)",
    d: "m0 0 2 1-3 3-1 23h-1v-25z",
    fill: "#7B86B0"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1652,739)",
    d: "m0 0 6 2 2 1v4l-4-1-5-3z",
    fill: "#F9F9F9"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1269,327)",
    d: "m0 0h6l-3 2-1 12h-2z",
    fill: "#645D7F"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(649,321)",
    d: "m0 0 5 1v5h-5l-1-5z",
    fill: "#262A3E"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(603,321)",
    d: "m0 0 6 1-1 5h-5z",
    fill: "#2B2D40"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1576,300)",
    d: "m0 0h3l-1 3h-3l1 4 7-1v2l-2 1h-6l-2-2v-5h3z",
    fill: "#494C6A"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1314,294)",
    d: "m0 0h8l-1 2-7 2-2 7h-1v-8z",
    fill: "#6A688D"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1263,294)",
    d: "m0 0h5l2 2-1 3-2-2h-4l-1 2 4 2 1 2-5-2-1-5z",
    fill: "#3E4669"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1200,295)",
    d: "m0 0 7 1 1 3-5 3-3-1z",
    fill: "#EAE9EC"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1579,264)",
    d: "m0 0h5l2 4-4 1-3-1-1 3z",
    fill: "#E9E6E8"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(363,257)",
    d: "m0 0h5l1 5-5 1-1-1z",
    fill: "#2B2E43"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1302,618)",
    d: "m0 0h17v1l-9 2-5-1z",
    fill: "#6D7AA2"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1560,296)",
    d: "m0 0 2 1v10l-3 2h-5l-3-1v-5l1 3 6 1 2-2z",
    fill: "#333852"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1313,268)",
    d: "m0 0 5 1 1 1v6h-9v-2l7 1v-4l-4-1z",
    fill: "#51516D"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1006,85)",
    d: "m0 0h1l1 10 3 1 1-3 1 7-3 1-1-3-3-2z",
    fill: "#F4F4F4"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(961,84)",
    d: "m0 0h5v4l-8 1v-4z",
    fill: "#DDD7DC"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(518,757)",
    d: "m0 0 7 1 7 3-4 2-10-5z",
    fill: "#F9F9F9"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1431,85)",
    d: "m0 0 3 4 1 7h-4z",
    fill: "#ECE9EB"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,84)",
    d: "m0 0h5l1 4h-9l1-3z",
    fill: "#E2DEE4"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1058 1e3)",
    d: "m0 0 2 3 2 9v6l-2-3-2-7z",
    fill: "#A1AECF"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1498,799)",
    d: "m0 0 1 2h12l1 3-13-1z",
    fill: "#A88198"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1602,296)",
    d: "m0 0 5 1v5l-5-2-1 2-1-4z",
    fill: "#F3F2F3"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1409,263)",
    d: "m0 0 5 1 1 2v7l-3 3-3-1 3-2v-7z",
    fill: "#474B68"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1466,84)",
    d: "m0 0h5l2 4h-9z",
    fill: "#E7E3E7"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1074,1072)",
    d: "m0 0 2 4 2 11h-2v-2l-5-1 3-1z",
    fill: "#7A85B1"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1364,293)",
    d: "m0 0 5 1-3 1 1 11 2 3-4-1z",
    fill: "#303A5A"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1521,296)",
    d: "m0 0h5l1 4-8 1 1-4z",
    fill: "#EEEFF3"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1373,262)",
    d: "m0 0 7 1 2 2v8h-2l-1-7-6-3z",
    fill: "#575A7C"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1241,84)",
    d: "m0 0 5 1-1 3-9 1 2-4z",
    fill: "#DED9DE"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(88,63)",
    d: "m0 0 2 4-3 10h-1l-1-9z",
    fill: "#38374D"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(130,61)",
    d: "m0 0h2l5 5 2 1v2h-5l-4-5z",
    fill: "#38384B"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,1080)",
    d: "m0 0 6 2v4h-2l-1 3z",
    fill: "#646D9C"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,1072)",
    d: "m0 0v3l-6 8-2-1 2-4 5-5z",
    fill: "#939FC5"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1770,886)",
    d: "m0 0 5 1 1 6h-3z",
    fill: "#F9F9F9"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1643,295)",
    d: "m0 0 4 1 1 2v10h-2l-1-10z",
    fill: "#3F476A"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1338,296)",
    d: "m0 0h5l1 4-5 2-2 1z",
    fill: "#F1F2F3"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1655,294)",
    d: "m0 0 7 1 1 4-3-2h-5l-2 6h-1v-6z",
    fill: "#46496A"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(88,105)",
    d: "m0 0h2l3 5 3 1v2h-5l-3-3z",
    fill: "#181D2C"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(888,76)",
    d: "m0 0 3 1v2h-2v2h-2l-1 2-1-2-3-1 1-3z",
    fill: "#EAE6E7"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1506,72)",
    d: "m0 0 5 1v4h-6z",
    fill: "#22283C"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(890,72)",
    d: "m0 0 5 1v4h-6z",
    fill: "#2A2D43"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1224,1114)",
    d: "m0 0 2 1 3 10v4h-2l-3-11z",
    fill: "#C2CCDC"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1040,1014)",
    d: "m0 0 6 2v3l-6 1-1-4z",
    fill: "#575D92"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1408,327)",
    d: "m0 0h2l-3 9-2 4h-3l2-4z",
    fill: "#3B4261"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1397,267)",
    d: "m0 0h1v8l-1 1h-10l1-3 1 1h5l2-2z",
    fill: "#353C59"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1312,262)",
    d: "m0 0h6l1 4h-2v-2h-5l-1 5h-1v-5z",
    fill: "#686987"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1533,262)",
    d: "m0 0h5v2l-5 2-2 7h-1v-7z",
    fill: "#565B7F"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(133,88)",
    d: "m0 0 4 1 4 4v3l-4-2v-2l-4-2z",
    fill: "#373951"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1448,84)",
    d: "m0 0h1v15h-1v-6h-2l1-7z",
    fill: "#E7E5E9"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(906,86)",
    d: "m0 0 1 3-1 6h5v2h-5l-2-2v-7z",
    fill: "#E9E7EA"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1027,651)",
    d: "m0 0 3 2-5 3h-10v-1l8-1 1-2z",
    fill: "#D4D7DD"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1288,328)",
    d: "m0 0h2v11l-4 1 1-2z",
    fill: "#3B4469"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(126,98)",
    d: "m0 0 4 1 3 3v4h-2l-5-6z",
    fill: "#2A2F45"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1331,84)",
    d: "m0 0 6 1 1 3h-7z",
    fill: "#EEEDED"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1270,72)",
    d: "m0 0 5 1-1 4-5-1z",
    fill: "#272D44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTamplate);
export default __webpack_public_path__ + "static/media/tamplate.1ddf87963310985faedc76ecdd87a4a2.svg";
export { ForwardRef as ReactComponent };